import {luiCheckAllowedValues, luiClassName} from "../../utils/lui"
import './LIcon.css'

/**
 *   Иконка Material-Icons
 *
 *  Для `styles` доступны переменные:
 *```
 *  --lui-icon-fontsize: 24px;
 *  --lui-icon-color: inherited;
 *```
 *
 *  @param {string} name - Имя иконки (см. описание имен на https://fonts.google.com/icons?icon.set=Material+Icons) //&#xe8b8
 *  @param {?string} title - title
 *  @param {string} size - стандарный размер: 1: 18px, 2: 24px, 3: 30px, 4: 36px, 5: 42px, 6: 48px
 *  @param {string} color - цвет: inherited (null), text, primary, secondary, grey, disabled
 *  @param {string} className - добавочный класс
 *  @param {string} type - тип иконки: null, 'outline', 'round', 'sharp', 'dual'
 *  @param {*} style - добавочный стиль
 *  @param {function{*}} onClick
 *  @returns {JSX.Element}
 *  @constructor
 */
export default function LIcon({ name, size='3', color, type, title=null, className, style, onClick }){

    // Проверка допустимых значений
    luiCheckAllowedValues({
        component: 'LIcon',
        allowed: {
            size:   '123456'.split(''),
            color:  [ 'inherited', 'text', 'text-var', 'primary', 'secondary', 'grey', 'disabled' ],
            type:   [ 'outline', 'round', 'sharp', 'dual' ]
        },
        values: arguments[0]
    })

    // Класс
    const classFin = luiClassName([
        '_LIcon_',
        className,
        color && `col-${color}`,
        size && `size${size}`,
        type && type,
    ])

    return (
        <div title={title} className={classFin} style={style} onClick={onClick} dangerouslySetInnerHTML={{__html: name}} />
    );
}
